
import React from 'react'
import icon from './svgs/medals.svg'
import { BaseIcon } from './_base'

export const MedalsIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
